/**
 * 定义全局过滤器
 */
import momentLib from 'moment';
export function unescape(text) {
    let res = text || '';
    [
        ['<p>', '\n'],
        ['&amp;', '&'],
        ['&amp;', '&'],
        ['&apos;', '\''],
        ['&#x27;', '\''],
        ['&#x2F;', '/'],
        ['&#39;', '\''],
        ['&#47;', '/'],
        ['&lt;', '<'],
        ['&gt;', '>'],
        ['&nbsp;', ' '],
        ['&quot;', '"']
    ].forEach(pair => {
        res = res.replace(new RegExp(pair[0], 'ig'), pair[1])
    });
    return res;
}

export function moment(value, display) {
    let newDate = momentLib(value);
    if (newDate.isValid()) {
        if (display === undefined)
            display = "YYYY-MM-DD";
        return newDate.format(display);
    } else
        return value;

}



// WEBPACK FOOTER //
// ./src/filters/index.js